import type { TypeSelectOption } from '@thefarmersfront/kitchen';

import type { TypeReturnDisposalOperationTimeApi } from '~/types/receive.types';

/**
 * 회수예정일 시간 옵션 조립 — 선택 날짜의 operation-times 슬롯을 Select 옵션으로 변환한다.
 *
 * @note 같은 날짜에 시작~종료가 동일한 슬롯이 여러 번 내려오면 첫 슬롯 하나로 중복 제거한다.
 *       (value=capaId → 신청 payload로 전송, text=`시작~종료` 범위 표시)
 */
export const getReturnDisposalTimeOptions = (
  operationTimes: TypeReturnDisposalOperationTimeApi[],
  selectedDate: string | null
): TypeSelectOption<string>[] => {
  if (!selectedDate) return [];

  const seen = new Set<string>();
  const options: TypeSelectOption<string>[] = [];

  for (const slot of operationTimes) {
    if (slot.date !== selectedDate) continue;

    const label = `${slot.startTime}~${slot.endTime}`;
    if (seen.has(label)) continue;

    seen.add(label);
    options.push({ value: String(slot.capaId), text: label });
  }

  return options;
};
